import { render, staticRenderFns } from "./CollectionsCarouselItem.vue?vue&type=template&id=514f07fa"
import script from "./CollectionsCarouselItem.vue?vue&type=script&lang=js"
export * from "./CollectionsCarouselItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports